export const USER_LANGUAGES_ENUM = {
  // SK: 'SK',
  EN: 'EN',
};

export const SYMBOL_TYPES = {
  CRYPTO: 'CRYPTO',
  FIAT: 'FIAT',
};

export const SYMBOL_NETWORK_TYPES = {
  TESTNET: 'TESTNET',
  MAINNET: 'MAINNET',
};

export const SYMBOLS = {
  EUR: 'EUR',
  USDT: 'USDT',
  USD: 'USD',
};

export const API_ERRORS = {
  INVALID_ACCOUNT_STATE: 'INVALID_ACCOUNT_STATE',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  UNSUPPORTED_EMAIL: 'UNSUPPORTED_EMAIL',
  WEAK_PASSWORD: 'WEAK_PASSWORD',
  INVALIDATED_JWT_TOKEN: 'INVALIDATED_JWT_TOKEN',
  DNS_ERROR: 'DNS_ERROR',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PAYMENT_NOT_FOUND: 'PAYMENT_NOT_FOUND',
  PAYMENT_EXPIRED: 'PAYMENT_EXPIRED',
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  MAX_PAYMENTS_LIMIT: 'MAX_PAYMENTS_LIMIT',
  OTP_INVALID: 'OTP_INVALID',
  OTP_RECOVERY_INVALID: 'OTP_RECOVERY_INVALID',
  WALLET_NOT_FOUND: 'WALLET_NOT_FOUND',

  // TODO
  // CAPTCHA_V3_FAILED: 'CAPTCHA_V3_FAILED',
  // CAPTCHA_V2_FAILED: 'CAPTCHA_V2_FAILED',
  // OTP_FAILED: 'OTP_FAILED',
};

export const KEY_SCOPES = {
  PAYMENT: 'PAYMENT',
};

export const PAYMENT_STATE_ENUM = {
  NEW: 'NEW',
  WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
  WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
  SUCCESS: 'SUCCESS',
  EXPIRED: 'EXPIRED',
};

export const SETTLEMENT_STATE_ENUM = {
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const WEBSOCKET_EVENTS = {
  JOIN_ROOM: 'JOIN_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM',
  PAYMENT_UPDATED: 'PAYMENT_UPDATED',
};

export const WEBSOCKET_ROOM_TYPES = {
  PAYMENT: 'PAYMENT',
  USER: 'USER',
};

// Order
export const ORDER_KEY = 'order';
export const ORDER_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};
